<button *ngIf="isAuthorized$ | async" class="dropdown-item"
        [routerLink]="['/' + getPageRoutePrefix(), contextMenuObject.id, 'edit']"
        [innerHTML]="'context-menu.actions.dso-page-edit.'+ contextMenuObjectType +'.btn' | translate">
</button>
